import(/* webpackMode: "eager" */ "/codegient-poc/app/globals.css");
import(/* webpackMode: "eager" */ "/codegient-poc/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/codegient-poc/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/codegient-poc/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/codegient-poc/components/ui/tooltip.tsx")